import CountryService from '../services/CountryService'
import { useCountryContext } from '../context/country/CountryProvider'
import { COUNTRY_ACTIONS } from '../context/country/COUNTRY_ACTIONS'

export default function useCountry() {
  const { countryDispatch } = useCountryContext()
  async function getCountry(countryId) {
    try {
      countryDispatch({
        type: COUNTRY_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await CountryService.getCountry(countryId)
      countryDispatch({
        type: COUNTRY_ACTIONS.SET_COUNTRY,
        payload: {
          country: data.country,
        },
      })
    } catch (error) {
    } finally {
      countryDispatch({
        type: COUNTRY_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }
  return { getCountry }
}
